import { Button, Icon, Modal, Text, View } from '@/components'
import { modal } from '@codeleap/modals'

export const ReportSuccessModal = modal().content(({ toggle }) => {

  return <View variants={['column', 'alignCenter', 'gap:2']}>
    <Text text={`Thanks for reporting!`} variants={['h4']}/>
    <Icon debugName='Report success' name='empty-check-circle' variants={['color:primary3', 'iconSize:5']}/>
    <Text text={`For your safety and experience, we will no longer show you content from this user.`} variants={['p1', 'textCenter']}/>
    <Button debugName='Dismiss report modal' text={`Done`} onPress={toggle} variants={['alignSelfStretch']}/>
  </View>
}).props({
  variants: ['centered'],
  showClose: false,
  style: {
    width: '18vw',
  },
})
